export const valueDelete = (value: any) => {
    if(value && value !== '') return value
    return 'Удалено'
}

export const getValue = (value: any) => {
    if(value && value !== '') return value
    return 'Не указано'
}
